import {
  Input,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@devhop/ui";
import { useId } from "react";
import type { ProductAllocationDraft } from "@/modules/cf-feed/presentation/lib/product-allocation";

export function ProductAllocationFields({
  value,
  onChange,
  disabled = false,
  isPreorder,
}: {
  value: ProductAllocationDraft;
  onChange: (value: ProductAllocationDraft) => void;
  disabled?: boolean;
  /** undefined ใช้เลือกนโยบายล่วงหน้าสำหรับ bulk ที่มีสินค้าหลายประเภท */
  isPreorder?: boolean;
}) {
  const id = useId();
  const mode = isPreorder === false ? "limit" : value.allocationMode;
  return (
    <div className="min-w-0 space-y-2">
      <Label htmlFor={id}>ໂໝດຮັບ CF</Label>
      <Select
        value={mode}
        disabled={disabled}
        onValueChange={(next) => {
          if (
            next === "limit" ||
            (next === "unlimited" && isPreorder !== false)
          )
            onChange({ allocationMode: next });
        }}
      >
        <SelectTrigger
          id={id}
          className="w-full min-w-0"
          aria-describedby={`${id}-hint`}
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="limit">ຈຳກັດຕາມສະຕັອກ POS</SelectItem>
          <SelectItem value="unlimited" disabled={isPreorder === false}>
            ບໍ່ຈຳກັດ (preorder)
          </SelectItem>
        </SelectContent>
      </Select>
      {mode === "limit" && (
        <div className="space-y-1">
          <Label htmlFor={`${id}-quantity`}>ຈຳນວນເປີດຂາຍໃນ Feed / Live</Label>
          <Input
            id={`${id}-quantity`}
            type="number"
            min={1}
            step={1}
            value={value.allocatedQuantity ?? ""}
            disabled={disabled}
            onChange={(event) =>
              onChange({
                allocationMode: "limit",
                allocatedQuantity:
                  event.target.value === ""
                    ? undefined
                    : Number(event.target.value),
              })
            }
          />
        </div>
      )}
      <p id={`${id}-hint`} className="text-muted-foreground text-xs">
        {isPreorder === false
          ? "POS ປິດ preorder · ຮັບ CF ໄດ້ຕາມສະຕັອກທີ່ເຫຼືອເທົ່ານັ້ນ"
          : mode === "limit"
            ? "ຈຳນວນທີ່ຮັບໄດ້ຈິງຈະບໍ່ເກີນທັງໂຄວຕ້ານີ້ ແລະສະຕັອກ POS ທີ່ເຫຼືອ"
            : "ໃຊ້ໄດ້ສະເພາະສິນຄ້າທີ່ POS ເປີດ preorder · ສິນຄ້າອື່ນຈຳກັດຕາມສະຕັອກ"}
      </p>
    </div>
  );
}
